var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.element != null)?_c('div',{staticClass:"col-xs-12 col-md-4"},[_vm._t("default"),_c('router-link',{attrs:{"to":_vm.navigateTo}},[_c('div',{staticClass:"card hover"},[_c('img',{attrs:{"src":_vm.imageUrl,"width":"100%"}}),_c('div',{staticClass:"description"},[_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.element.Title)))])])])])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }